/**
 * airan-ntn — TN-NTN Steering xApp
 * Steers UEs between terrestrial and non-terrestrial networks
 */

import { XAppBase } from './XAppBase.js';
import { E2KpmReport, E2RcAction, XAppDecision } from '../types.js';

export class TnNtnSteeringXApp extends XAppBase {
  private lastReports: Map<number, E2KpmReport> = new Map();

  constructor(enabled: boolean = true) {
    super('tn-ntn-steering', enabled);
  }

  processKpmReport(report: E2KpmReport): void {
    this.lastReports.set(report.gnbId, report);
  }

  decisionCycle(): XAppDecision {
    const start = performance.now();
    const actions: E2RcAction[] = [];

    for (const [gnbId, report] of this.lastReports) {
      const tnLoad = report.sliceMetrics.find(s => s.sliceId === 1)?.prbUsed ?? 0;
      const ntnLoad = report.sliceMetrics.find(s => s.sliceId === 3)?.prbUsed ?? 0;
      if (tnLoad > ntnLoad * 1.5) {
        actions.push({
          type: 'TX_POWER_CONTROL',
          targetId: gnbId,
          payload: { powerDb: 30, target: 'ntn' },
          priority: this.config.priority,
          timestamp: Date.now()
        });
      }
    }

    const latency = performance.now() - start;
    this.recordDecision(latency);

    return { actions, confidence: 0.8, latencyMs: latency };
  }

  getRequiredSubscription(): { eventTriggers: string[]; reportStyle: string } {
    return {
      eventTriggers: this.config.requiredEventTriggers,
      reportStyle: this.config.requiredReportStyle
    };
  }
}